// React
import React, { useEffect } from "react";

//Redux
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../../../actions';
import moment from 'moment';

//Controllers
import { getAnaliticTitlesByPeriod } from "../../../../controllers/TitleController";

//Material UI
import { makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { TableFooter } from "@material-ui/core";
import PrintIcon from '@material-ui/icons/Print';
import Typography from '@material-ui/core/Typography';
import _ from 'lodash';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';

//Custom components
import MyTable from '../../../utils/MyTable';
import UnoButton from '../../../utils/UnoButton';

//Custom styles
import { headerSearch, tabs, unoTheme } from '../../../../assets/styles/unoTheme';

//Utils
import {
    getFirstDayMonth,
    getLastDayInMonthByMonthAndYear,
    getShortMonthName,
    applyMaskAmount,
    getMonthsUntilPortfolioInit,
    getMonthsByArray,
    getDayMonthYearByStringDate,
    getFirstPtDayOfYear,
    getLastPtDayMonth
} from "../../../utils/utils";
import XLSX from 'xlsx';
import { downloadBlob, s2ab } from "../../../../controllers/ExcelController";
import { getInfosTitlesAndSaveByListCodTitles } from "../../../../controllers/ComdinheiroController";
import MySelect from '../../../utils/MySelect';
import MyInnerLoad from '../../../utils/MyInnerLoad';
import { useState } from "react";
import { useMemo } from "react";
import { useCallback } from "react";
import { useRef } from "react";
import { getRegimeLabel, getRegimeOptions, parseRegimeValue, REGIME_SHEET_LABELS } from '../../../utils/accountRegimes';
import {
    calculateTitlePerformance,
    calculateTotals,
} from './comparisonCalc';
import { ComDinheiroAPI } from "../../../../API/comdinheiro-api";
import { TitleLocalQuotasAPI } from "../../../../API/title_local_quotas";
import { formatTitleLocalQuotasMonthYear } from "../../../../controllers/TitleLocalQuotasController";
import { IpcadpLocalAPI } from "../../../../API/ipcadp_local";
import { formatIpcaDpMonthYear } from "../../../../controllers/IpcaDpLocalController";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: 'red',
    },
    iconButton: {
        padding: '5px',
    },
    headerSearch: {
        ...headerSearch,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'nowrap',
    },
    inputSearch: {
        width: "300px",
        background: "white"
    },

    tabs: tabs,
    leftHeader: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
    },
    rightHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    filterContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginLeft: '20px'
    },

    smallTextsCells: {
        '& .MuiTableCell-root ': {
            fontSize: '0.9em',
        }
    },

    myTableFooter: {
        cursor: "pointer",
        borderBottom: 'unset',
        '& > *': {
            borderBottom: 'unset',
        },
        '& .MuiTableCell-root': {
            borderBottom: 'unset',
            color: 'white',
            background: unoTheme.mainColor,
        },

        '& .totalLineInvestiments': {
            '& .MuiTableCell-root': {
                color: 'black',
                borderBottom: 'unset',
                background: unoTheme.mainGrayColor,
            },
        },

        '& .MuiTableCell-root:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
            textWrap: 'nowrap'
        },

        '& .MuiTableCell-root:last-child': {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        },

        '& .spanTotal': {
            whiteSpace: 'nowrap'
        }
    },

}));

export default function CurveXMarketScreen() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const clientOn = useSelector(state => state.clientOn)

    //titles

    const [periodType, setPeriodType] = useState('month');
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedQuarter, setSelectedQuarter] = useState(1);
    const [selectedSemester, setSelectedSemester] = useState(1);
    const [portfolioMonths, setPortfolioMonths] = useState([]);
    const [portfolioYears, setPortfolioYears] = useState([]);
    const [formattedPortfolioData, setFormattedPortfolioData] = useState({ months: {}, years: [] });
    const [publicTitles, setPublicTitles] = React.useState(null);
    const [titleAnalytics, setTitleAnalytics] = useState();
    const [totalsCalculated, setTotalsCalculated] = useState(null);
    const [orderBy, setOrderBy] = useState("purchaseDate");
    const [order, setOrder] = useState("desc")
    const [date, setDate] = useState();
    const [ipcaDp, setIpcaDp] = useState([]);
    const [quotasAnb, setQuotasAnb] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [segregationSelected, setSegregationSelected] = useState(0);

    const accountRegimeId = parseRegimeValue(segregationSelected);

    const segregationsOptions = useMemo(
        () => getRegimeOptions(clientOn, { includeConsolidated: true }),
        [clientOn]);

    //Identifica a carga mais recente: respostas de seleções anteriores (período/segregação) são descartadas
    const loadRequestRef = useRef(0);

    const initializePortfolioMonthsAndYears = useCallback((client) => {
        if (client && client.portfolio_init) {
            const portfolioData = getMonthsUntilPortfolioInit(
                client.portfolio_init,
                client.portfolio_closed || new Date()
            );

            setFormattedPortfolioData(portfolioData);
            setPortfolioYears(portfolioData.years || []);

            const currentYear = portfolioData.years ? portfolioData.years[portfolioData.years.length - 1] : new Date().getFullYear();
            setSelectedYear(currentYear);

            if (portfolioData.months && portfolioData.months[currentYear]) {
                const monthsArray = getMonthsByArray(portfolioData.months[currentYear]);
                setPortfolioMonths(monthsArray);

                if (monthsArray.length > 0) {
                    setSelectedMonth(monthsArray[monthsArray.length - 1].id);
                }
            }
        }
    }, []);

    const availableQuarters = useMemo(() => {
        if (!portfolioMonths.length || periodType !== 'quarter') return [];

        const quarters = [];
        const monthIds = portfolioMonths.map(m => m.id);

        for (let quarter = 1; quarter <= 4; quarter++) {
            const startMonth = (quarter - 1) * 3 + 1;
            const endMonth = startMonth + 2;

            const hasAllMonths = [startMonth, startMonth + 1, endMonth]
                .every(month => monthIds.includes(month));

            if (hasAllMonths) {
                quarters.push(quarter);
            }
        }

        return quarters;
    }, [portfolioMonths, periodType, selectedYear]);

    const availableSemesters = useMemo(() => {
        if (!portfolioMonths.length || periodType !== 'semester') return [];

        const semesters = [];
        const monthIds = portfolioMonths.map(m => m.id);

        for (let semester = 1; semester <= 2; semester++) {
            const startMonth = (semester - 1) * 6 + 1;
            const endMonth = startMonth + 5;

            const hasAllMonths = [startMonth, startMonth + 1, startMonth + 2,
                startMonth + 3, startMonth + 4, endMonth]
                .every(month => monthIds.includes(month));

            if (hasAllMonths) {
                semesters.push(semester);
            }
        }

        return semesters;
    }, [portfolioMonths, periodType, selectedYear]);

    useEffect(() => {
        if (selectedYear && formattedPortfolioData.months && formattedPortfolioData.months[selectedYear]) {
            const monthsArray = getMonthsByArray(formattedPortfolioData.months[selectedYear]);
            setPortfolioMonths(monthsArray);

            if (monthsArray.length > 0 && (!selectedMonth || !monthsArray.some(m => m.id === selectedMonth))) {
                setSelectedMonth(monthsArray[monthsArray.length - 1].id);
            }
        }
    }, [selectedYear, formattedPortfolioData]);

    useEffect(() => {
        if (periodType === 'quarter') {
            if (availableQuarters.length > 0) {
                if (!availableQuarters.includes(selectedQuarter)) {
                    setSelectedQuarter(availableQuarters[availableQuarters.length - 1]); // último válido
                }
            } else {
                setSelectedQuarter(null); // não existe trimestre válido
            }
        }

        if (periodType === 'semester') {
            if (availableSemesters.length > 0) {
                if (!availableSemesters.includes(selectedSemester)) {
                    setSelectedSemester(availableSemesters[availableSemesters.length - 1]); // último válido
                }
            } else {
                setSelectedSemester(null); // não existe semestre válido
            }
        }
    }, [availableQuarters, availableSemesters, periodType]);

    const getPeriodDates = useCallback(() => {
        let startDate, endDate, displayMonth, displayYear;

        const fallbackYear = formattedPortfolioData.years.length > 0
            ? formattedPortfolioData.years[formattedPortfolioData.years.length - 1]
            : new Date().getFullYear();

        const yearToUse = (selectedYear && formattedPortfolioData.years.includes(selectedYear))
            ? selectedYear
            : fallbackYear;

        const monthsForYear = formattedPortfolioData.months?.[yearToUse] || [];
        const fallbackMonth = monthsForYear.length > 0 ? monthsForYear[monthsForYear.length - 1] : 12;

        const monthToUse = (selectedMonth && monthsForYear.includes(selectedMonth))
            ? selectedMonth
            : fallbackMonth;

        switch (periodType) {
            case 'month':
                startDate = getFirstDayMonth(monthToUse, yearToUse);
                endDate = getLastDayInMonthByMonthAndYear(monthToUse, yearToUse);
                displayMonth = monthToUse;
                displayYear = yearToUse;
                setDate({ startDate, endDate, displayMonth, displayYear })
                break;
            case 'quarter': {
                let validQuarter = selectedQuarter;
                if (!validQuarter || !availableQuarters.includes(validQuarter)) {
                    validQuarter = availableQuarters.length > 0 ? availableQuarters[availableQuarters.length - 1] : 1;
                }
                const quarterStartMonth = (validQuarter - 1) * 3 + 1;
                const quarterEndMonth = quarterStartMonth + 2;
                startDate = getFirstDayMonth(quarterStartMonth, yearToUse);
                endDate = getLastDayInMonthByMonthAndYear(quarterEndMonth, yearToUse);
                displayMonth = quarterStartMonth;
                displayYear = yearToUse;
                setDate({ startDate, endDate, displayMonth, displayYear })
                break;
            }
            case 'semester': {
                let validSemester = selectedSemester;
                if (!validSemester || !availableSemesters.includes(validSemester)) {
                    validSemester = availableSemesters.length > 0 ? availableSemesters[availableSemesters.length - 1] : 1;
                }
                const semesterStartMonth = (validSemester - 1) * 6 + 1;
                const semesterEndMonth = semesterStartMonth + 5;
                startDate = getFirstDayMonth(semesterStartMonth, yearToUse);
                endDate = getLastDayInMonthByMonthAndYear(semesterEndMonth, yearToUse);
                displayMonth = semesterStartMonth;
                displayYear = yearToUse;
                setDate({ startDate, endDate, displayMonth, displayYear })
                break;
            }
            case 'year':
                startDate = getFirstPtDayOfYear(yearToUse);
                endDate = getLastPtDayMonth(monthToUse, yearToUse);
                displayMonth = monthToUse;
                displayYear = yearToUse;
                setDate({ startDate, endDate, displayMonth, displayYear })
                break;
            case 'fromStart': {
                const firstYear = formattedPortfolioData.years[0];
                const lastYear = formattedPortfolioData.years[formattedPortfolioData.years.length - 1];
                const firstMonths = formattedPortfolioData.months?.[firstYear] || [];
                const lastMonths = formattedPortfolioData.months?.[lastYear] || [];
                const firstMonth = firstMonths.length > 0 ? firstMonths[0] : 1;
                const lastMonth = lastMonths.length > 0 ? lastMonths[lastMonths.length - 1] : 12;
                startDate = getFirstDayMonth(firstMonth, firstYear);
                endDate = getLastDayInMonthByMonthAndYear(lastMonth, lastYear);
                displayMonth = lastMonth;
                displayYear = lastYear;
                setDate({ startDate, endDate, displayMonth, displayYear });
                break;
            }
        }

        return { startDate, endDate, displayMonth, displayYear };

    }, [periodType,
        selectedMonth,
        selectedYear,
        selectedQuarter,
        selectedSemester,
        availableQuarters,
        availableSemesters,
        formattedPortfolioData]);

    async function loadTitles(client, regimeId) {
        const requestId = ++loadRequestRef.current;
        const { startDate, endDate, displayMonth, displayYear } = getPeriodDates();
        const { month: mStart, year: yStart } = getDayMonthYearByStringDate(startDate);
        const { month, year } = getDayMonthYearByStringDate(endDate);

        dispatch(
            allActions.innerLoadActions.setInnerLoad({
                show: true,
                loadMessage: 'Carregando títulos...'
            }));



        if (noValidPeriod) {
            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: true,
                emptyMessage: `Não existe ${periodType === 'semester' ? 'semestre' : 'trimestre'} fechado para ${selectedYear}.`
            }));
            return;
        }

        if (!formattedPortfolioData.months?.[displayYear]?.includes(displayMonth)) {
            return;
        }

        // console.log("allTitles startDate: ", startDate);
        // console.log("allTitles endDate: ", endDate);
        // console.log("allTitles displayMonth: ", displayMonth);
        // console.log("allTitles displayYear: ", displayYear);
        // console.log("allTitles mStart: ", mStart);
        // console.log("allTitles month: ", month);
        // console.log("allTitles yStart: ", yStart);
        // console.log("allTitles year: ", year);

        const {
            allTitles,
        } = await getAnaliticTitlesByPeriod(
            client.id,
            startDate,
            endDate,
            displayMonth,
            displayYear,
            (mStart != month) || (yStart != year),
            regimeId
        );

        if (requestId !== loadRequestRef.current) return;

        const response = await getInfosTitlesAndSaveByListCodTitles(allTitles.filter(el => el.sector == 'PUBLICO'), startDate, endDate)

        if (requestId !== loadRequestRef.current) return;

        if (response) {
            setPublicTitles(response);
            return;
        };
        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            emptyMessage: regimeId ? 'Não existem títulos para a segregação selecionada' : 'Não existem títulos'
        }));
    };

    useEffect(() => {
        if (clientOn && clientOn.client) {
            initializePortfolioMonthsAndYears(clientOn.client);
        }
    }, [clientOn, initializePortfolioMonthsAndYears]);

    //O regime escolhido para o cliente anterior pode não estar habilitado para o novo
    useEffect(() => {
        setSegregationSelected(0);
    }, [clientOn?.client?.id]);

    useEffect(() => {
        if (clientOn && clientOn.client && selectedMonth && selectedYear) {
            setIsLoading(true);
            setTitleAnalytics([])
            setTotalsCalculated({})
            setPublicTitles([])
            loadTitles(clientOn.client, accountRegimeId);
        }
    }, [clientOn, periodType, selectedMonth, selectedYear, selectedQuarter, selectedSemester, accountRegimeId]);

    function doExcel(items, displayMonth, displayYear) {
        const regimeSuffix = accountRegimeId ? `_${REGIME_SHEET_LABELS[accountRegimeId]}` : '';
        const fileName = `Curva_vs_Mercado_${getShortMonthName(displayMonth)}_${displayYear}${regimeSuffix}`;

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando planilha...',
        }));

        const wb = XLSX.utils.book_new();

        wb.Props = {
            Title: fileName,
            Author: "UNO",
        };

        //Nome da aba do XLSX tem limite de 31 caracteres
        const sheetName = fileName.slice(0, 31);
        wb.SheetNames.push(sheetName);

        const ws_data = [];

        // Cabeçalho
        ws_data.push([
            'ATIVO',
            'DATA DE COMPRA',
            'MARCAÇÃO',
            'FINANCEIRO CURVA (R$)',
            'RETORNO CURVA',
            'FINANCEIRO MERCADO (R$)',
            'RETORNO MERCADO',
            'DIFERENÇA (R$)',
        ]);

        // Dados
        const arrayItems = Object.values(items);
        arrayItems.forEach((row, index) => {

            ws_data.push([
                row.titleName,
                row.purchaseDate,
                row.marking,
                row && row.curveAmount ? row.curveAmount.toFixed(2) : '',
                row && row.curveReturn !== null && row.curveReturn !== undefined && row.curveYield !== null && row.curveYield !== undefined
                    ? applyMaskAmount(row.curveReturn, true) + " ( " + applyMaskAmount(row.curveYield) + "%" + " )"
                    : "-",
                row && row.marketAmount ? row.marketAmount.toFixed(2) : '',
                row && row.marketReturn !== null && row.marketReturn !== undefined && row.marketYield !== null && row.marketYield !== undefined
                    ? applyMaskAmount(row.marketReturn, true) + " ( " + applyMaskAmount(row.marketYield) + "%" + " )"
                    : "-",
                row && row.difference !== null ? row.difference.toFixed(2) : '',
            ]);
        });

        // Linha de totais
        if (totalsCalculated) {
            ws_data.push([]);
            ws_data.push([
                `TOTAL (${totalsCalculated.titleCount} títulos)`,
                '',
                '',
                totalsCalculated.totalCurveAmount.toFixed(2),
                '',
                totalsCalculated.totalMarketAmount.toFixed(2),
                '',
                totalsCalculated.totalDifference.toFixed(2),
            ]);
        }

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        // Largura das colunas
        ws['!cols'] = [
            { wch: 16 },
            { wch: 15 },
            { wch: 12 },
            { wch: 24 },
            { wch: 20 },
            { wch: 24 },
            { wch: 20 },
            { wch: 16 },
        ];

        wb.Sheets[sheetName] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName + '.xlsx');

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));
    }

    const periodOptions = [
        { value: 'month', label: 'Mensal' },
        { value: 'quarter', label: 'Trimestral' },
        { value: 'semester', label: 'Semestral' },
        { value: 'year', label: 'Anual' },
        { value: 'fromStart', label: 'Desde o Início' },
    ];

    const monthOptions = portfolioMonths.map(month => ({
        value: month.id,
        label: month.name
    }));

    const quarterOptions = availableQuarters.map(quarter => ({
        value: quarter,
        label: `${quarter}º Trimestre`
    }));

    const semesterOptions = availableSemesters.map(semester => ({
        value: semester,
        label: `${semester}º Semestre`
    }));

    const yearOptions = portfolioYears.map(year => ({
        value: year,
        label: year.toString()
    }));

    const noValidPeriod = useMemo(() => {
        if (periodType === 'semester' && !availableSemesters.length) return true;
        if (periodType === 'quarter' && !availableQuarters.length) return true;
        return false;
    }, [periodType, availableSemesters, availableQuarters]);

    useEffect(() => {
        const fetchIPCAAndQuotasAnb = async () => {
            const { startDate, endDate } = getPeriodDates();
            try {
                const ipcaDpResponse = await IpcadpLocalAPI.getIpcaDpPeriod(startDate, endDate);
                const allLocalIpcaDpFiltered = formatIpcaDpMonthYear(ipcaDpResponse.body.rows)

                const titleIds = Array.from(
                    new Set(
                        publicTitles
                            .map(t => t.title_id)
                            .filter(Boolean)
                    )
                );

                const allLocalQuotasByTitleIdAndPeriod = await Promise.all(
                    titleIds.map(async (titleId) => {
                        const titleLocalQuotasResponse = await TitleLocalQuotasAPI.getTitleLocalQuotasTitleByIdAndPeriod(
                            titleId,
                            startDate,
                            endDate);
                        const formatted = formatTitleLocalQuotasMonthYear(titleLocalQuotasResponse.body.rows);
                        return { titleId, quotasAnb: formatted };
                    })
                );

                setQuotasAnb(allLocalQuotasByTitleIdAndPeriod);
                setIpcaDp(allLocalIpcaDpFiltered)
            } catch (error) {
                console.error("Erro ao buscar IPCA:", error);
                setQuotasAnb({});
                setIpcaDp({});
            }
        };

        if (publicTitles && publicTitles.length > 0) {
            fetchIPCAAndQuotasAnb();
        }
    }, [publicTitles, periodType, selectedMonth, selectedYear, selectedQuarter, selectedSemester]);

    useEffect(() => {
        if (!ipcaDp || ipcaDp.length === 0) return;
        if (!quotasAnb) return;

        const calculateTitleAnalytics = async () => {
            if (publicTitles && publicTitles.length > 0) {
                const { startDate, endDate } = getPeriodDates();

                try {
                    const titleAnalytics = await Promise.all(
                        publicTitles.map((title) => calculateTitlePerformance(title, startDate, endDate, ipcaDp, quotasAnb, periodType))
                    );


                    const filteredAnalytics = titleAnalytics.filter(Boolean);

                    setTitleAnalytics(filteredAnalytics);

                    const totals = calculateTotals(filteredAnalytics);
                    setTotalsCalculated(totals);
                    setIsLoading(false);

                    dispatch(
                        allActions.innerLoadActions.setInnerLoad({
                            show: false,
                            loadMessage: "Carregando títulos...",
                        })
                    );
                } catch (error) {
                    console.error("Error calculating title performance:", error);
                }
            }
        };

        calculateTitleAnalytics();
    }, [ipcaDp, quotasAnb]);


    const sortedTitles = useMemo(() => {
        if (!titleAnalytics) return [];
        if (!orderBy) return titleAnalytics;

        return _.orderBy(
            titleAnalytics,
            [(item) => {
                if (orderBy === "purchaseDate") {
                    return moment(item.purchaseDate, "DD/MM/YYYY").toDate();
                }
                return item[orderBy];
            }],
            [order]
        );
    }, [titleAnalytics, orderBy, order]);

    const SortIcon = ({ column }) => {
        const isActive = orderBy === column;
        if (!isActive) {
            return <ArrowDropDown style={{ color: "#ccc" }} />;
        }
        return order === "asc" ? (
            <ArrowDropUp style={{ color: unoTheme.mainColor }} />
        ) : (
            <ArrowDropDown style={{ color: unoTheme.mainColor }} />
        );
    };

    const handleSort = (column) => {
        if (orderBy === column) {
            setOrder(order === "asc" ? "desc" : "asc");
        } else {
            setOrderBy(column);
            setOrder("asc");
        }
    };

    return (
        <div className={classes.root}>

            <div className={classes.headerSearch}>
                <Typography variant="h6" gutterBottom align="left">
                    CURVA x MERCADO
                </Typography>
                <div className={classes.rightHeader}>
                    <div className={classes.filterContainer}>
                        {clientOn?.client?.is_cotization_segregation && (
                            <MySelect
                                value={segregationSelected}
                                onChange={(e) => setSegregationSelected(e.target.value)}
                                options={segregationsOptions.map((row, index) => (
                                    <option key={'segregation-selected-curvexmarket-' + index} value={row.value}>{row.name}</option>
                                ))}
                                customWidth="200px"
                            />
                        )}

                        <MySelect
                            value={periodType}
                            onChange={(e) => setPeriodType(e.target.value)}
                            options={periodOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                            customWidth="150px"
                        />

                        {(periodType === 'month') && (
                            <MySelect
                                value={selectedMonth || ''}
                                onChange={(e) => setSelectedMonth(Number(e.target.value))}
                                options={monthOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                                customWidth="140px"
                            />
                        )}

                        {periodType === 'quarter' && availableQuarters.length > 0 && (
                            <MySelect
                                value={selectedQuarter}
                                onChange={(e) => setSelectedQuarter(Number(e.target.value))}
                                options={quarterOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                                customWidth="180px"
                            />
                        )}

                        {periodType === 'semester' && availableSemesters.length > 0 && (
                            <MySelect
                                value={selectedSemester}
                                onChange={(e) => setSelectedSemester(Number(e.target.value))}
                                options={semesterOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                                customWidth="160px"
                            />
                        )}

                        {periodType !== 'fromStart' && (
                            <MySelect
                                value={selectedYear || ''}
                                onChange={(e) => setSelectedYear(Number(e.target.value))}
                                options={yearOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                                customWidth="100px"
                            />
                        )}
                    </div>

                    <UnoButton
                        style={{ marginRight: "8px" }}
                        size={'small'}
                        disabled={isLoading}
                        onClick={() => {
                            const { displayMonth, displayYear } = getPeriodDates();
                            doExcel(sortedTitles, displayMonth, displayYear);
                        }}
                        type='success'
                        startIcon={<PrintIcon />}>
                        {"Excel"}
                    </UnoButton>
                    <UnoButton
                        size={'small'}
                        className={classes.spacingLeft1}
                        disabled={isLoading}
                        onClick={() => dispatch(allActions.reportLoadActions.setReportLoad({
                            show: true,
                            reportType: 'curveXMarket',
                            message: 'Gerando o relatório...',
                            reportData: { client: clientOn.client, rows: sortedTitles, totals: totalsCalculated },
                            startDate: date.startDate,
                            endDate: date.endDate,
                            periodType,
                            regimeLabel: accountRegimeId ? getRegimeLabel(accountRegimeId) : null,
                        }))}
                        type='primary'
                        startIcon={<PrintIcon />}>
                        {"Gerar relatório"}
                    </UnoButton>
                </div>
            </div>

            <div class={'defaultScrollWithHeaderContent'}>
                {(titleAnalytics && titleAnalytics.length > 0 && !noValidPeriod) ?
                    <MyTable
                        stickyHeader
                        size="small">
                        <colgroup>
                            <col />
                            <col />
                            <col />
                            <col width="14%" />
                            <col width="14%" />
                            <col width="14%" />
                            <col width="14%" />
                            <col width="14%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ whiteSpace: 'nowrap' }} align="center">Ativo</TableCell>
                                <TableCell style={{ whiteSpace: 'nowrap' }} onClick={() => handleSort("purchaseDate")} align="center">
                                    <div style={{ display: 'flex', justifyContent: "center", alignItems: 'center', }}>
                                        Data de Compra <SortIcon column={"purchaseDate"} />
                                    </div>
                                </TableCell>
                                <TableCell style={{ whiteSpace: 'nowrap' }} align="center">Marcação</TableCell>
                                <TableCell style={{ whiteSpace: 'nowrap' }} onClick={() => handleSort("curveAmount")} align="center">
                                    <div style={{ display: 'flex', justifyContent: "center", alignItems: 'center', }}>
                                        Financeiro Curva (R$) (1) <SortIcon column={"curveAmount"} />
                                    </div>
                                </TableCell>
                                <TableCell style={{ whiteSpace: 'nowrap' }} onClick={() => handleSort("curveReturn")} align="center">
                                    <div style={{ display: 'flex', justifyContent: "center", alignItems: 'center', }}>
                                        Retorno Curva <SortIcon column={"curveReturn"} />
                                    </div>
                                </TableCell>
                                <TableCell style={{ whiteSpace: 'nowrap' }} onClick={() => handleSort("marketAmount")} align="center">
                                    <div style={{ display: 'flex', justifyContent: "center", alignItems: 'center', }}>
                                        Financeiro Mercado (R$) (2) <SortIcon column={"marketAmount"} />
                                    </div>
                                </TableCell>
                                <TableCell style={{ whiteSpace: 'nowrap' }} onClick={() => handleSort("marketReturn")} align="center">
                                    <div style={{ display: 'flex', justifyContent: "center", alignItems: 'center', }}>
                                        Retorno Mercado <SortIcon column={"marketReturn"} />
                                    </div>
                                </TableCell>
                                <TableCell style={{ whiteSpace: 'nowrap' }} align="center">Diferença (marcação − outra)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sortedTitles && sortedTitles.map((row, index) => {

                                return (
                                    <TableRow key={'title-curvexmarket-' + index} className={classes.smallTextsCells}>

                                        <TableCell align="center">{row.titleName}</TableCell>
                                        <TableCell align="center">{moment.utc(row.purchaseDate, "DD/MM/YYYY").format('DD/MM/YYYY')}</TableCell>
                                        <TableCell align="center">{row.marking}</TableCell>

                                        {/* Financeiro Curva */}
                                        <TableCell align="center">
                                            {row && row.curveAmount ?
                                                applyMaskAmount(row.curveAmount, true) : "-"}
                                        </TableCell>

                                        {/* Retorno Curva */}
                                        <TableCell align="center" className={row?.curveYield > 0 ? classes.green : classes.red}>
                                            {row && row.curveReturn !== null && row.curveReturn !== undefined && row.curveYield !== null && row.curveYield !== undefined
                                                ? applyMaskAmount(row.curveReturn, true) + " ( " + applyMaskAmount(row.curveYield) + "%" + " )"
                                                : "-"}
                                        </TableCell>

                                        {/* Financeiro Mercado */}
                                        <TableCell align="center">
                                            {row && row.marketAmount ?
                                                applyMaskAmount(row.marketAmount, true) : "-"}
                                        </TableCell>

                                        {/* Retorno Mercado */}
                                        <TableCell align="center" className={row?.marketYield > 0 ? classes.green : classes.red}>
                                            {row && row.marketReturn !== null && row.marketReturn !== undefined && row.marketYield !== null && row.marketYield !== undefined
                                                ? applyMaskAmount(row.marketReturn, true) + " ( " + applyMaskAmount(row.marketYield) + "%" + " )"
                                                : "-"}
                                        </TableCell>

                                        {/* Diferença */}
                                        <TableCell align="center">
                                            {row && row.difference !== null && row.difference !== undefined ? (
                                                <span className={row.difference >= 0 ? classes.green : classes.red}>
                                                    {applyMaskAmount(row.difference, true)}
                                                </span>
                                            ) : "-"}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>

                        {
                            totalsCalculated ?
                                <TableFooter className={classes.myTableFooter}>
                                    <TableRow className='totalLinePL' key={'footer-t-titles-analisys-total'}>
                                        <TableCell align="left">Total ({totalsCalculated.titleCount} títulos)</TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center">
                                            <span className={'spanTotal'}>
                                                {applyMaskAmount(totalsCalculated.totalCurveAmount, true)}
                                            </span>
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center">
                                            <span className={'spanTotal'}>
                                                {applyMaskAmount(totalsCalculated.totalMarketAmount, true)}
                                            </span>
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center">
                                            <span className={'spanTotal'}>
                                                {applyMaskAmount(totalsCalculated.totalDifference, true)}
                                            </span>
                                        </TableCell>
                                    </TableRow>
                                </TableFooter>
                                : null
                        }
                    </MyTable>
                    :
                    <>
                        <MyInnerLoad message={'Carregando títulos...'} />
                    </>
                }

            </div>


        </div >
    );
}



